import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BookingPeriodResponse, FilterState, homePageListings, ListingResponse, ListingsResponse, publicListingsResponse, ReviewResponse, ReviewSummaryResponse,   } from "./interface";
import { LISTING_VERIFICATION_STATUS } from "./features";


interface initialState {
    listing:ListingResponse|null,
    listings:ListingsResponse|null
    spaceType:
      | "event_center"
      | "experiences"
      | "retail"
      | "beachfront_villas"
      | "apartments"
      | "sightseeing_tours"
      | "private_boat_cruise"
      | null | string
    publicListings:publicListingsResponse|null
    filters: FilterState;
    search: string
    isFilterActive: boolean;
    bookingPeriod: BookingPeriodResponse|null
    homePageListings:homePageListings|null
    reviews:ReviewResponse|null
    reviewSummary:ReviewSummaryResponse|null
    
}

const initialState:initialState ={
    listing:null,
    listings:null,
    spaceType:null,
    homePageListings:null,
    publicListings:null,
    filters: {
      location: "",
      rating: undefined,
      use_cases: [],
      amenities: [],
      price: { from: "100", to: "100000" },
      size: { from: "400", to: "700" },
      distance: "10",
      verification_status: LISTING_VERIFICATION_STATUS.APPROVED,
    },
    search: "",
    bookingPeriod:null,
    isFilterActive: false,
    reviews:null,
    reviewSummary:null
    
}

export const listingSlice = createSlice({
    name:'listing',
    initialState,
    reducers:{
       setListing:(state:initialState, action:PayloadAction<ListingResponse>)=>{
        state.listing = action.payload

       },
       setListings:(state:initialState, action:PayloadAction<ListingsResponse>)=>{
        state.listings = action.payload
       },
       setFilters: (state, action: PayloadAction<FilterState>) => {
        state.filters = action.payload
        state.isFilterActive = Object.keys(action.payload).length > 0
      },
  
      // Update a single filter field
      updateFilter: (state, action: PayloadAction<{ key: keyof FilterState; value: any }>) => {
        const { key, value } = action.payload
        state.filters[key] = value
        state.isFilterActive = true
      },
  
      // Update search query
      setSearchQuery: (state, action: PayloadAction<string>) => {
        state.search= action.payload
      },
  
      // Reset filters to initial state
      resetFilters: (state) => {
        state.filters = initialState.filters
        state.isFilterActive = false
      },
      setSpaceType:(state:initialState, action: PayloadAction<   
    | "event_center"
    | "experiences"
    | "retail"
    | "beachfront_villas"
    | "apartments"
    | "sightseeing_tours"
    | "private_boat_cruise"
    | null | string>)=>{
        state.spaceType = action.payload

      },
      // Initialize filters from URL or other source
      initializeFilters: (state, action: PayloadAction<FilterState>) => {
        state.filters = {
          ...initialState.filters,
          ...action.payload,
        }
        state.isFilterActive = Object.keys(action.payload).length > 0
      },
       setPublicListings:(state:initialState, action:PayloadAction<publicListingsResponse>)=>{
        state.publicListings = action.payload
       } ,
       
       setHomePageListing:(state:initialState, action:PayloadAction<homePageListings>)=>{
        state.homePageListings = action.payload
       } ,

       setReviewResponse:(state:initialState, action:PayloadAction<ReviewResponse>)=>{
        state.reviews = action.payload
       },
       setBookingPeriod:(state:initialState, action:PayloadAction<BookingPeriodResponse>)=>{
        state.bookingPeriod = action.payload
       },
       setReviewSummary:(state:initialState, action:PayloadAction<ReviewSummaryResponse>)=>{
        state.reviewSummary = action.payload
       }
    }

})



export const {
    setListing,
    setListings,
    setBookingPeriod,
    setReviewResponse,
    setSpaceType,
    setHomePageListing,
    setReviewSummary,
    setFilters, updateFilter, setSearchQuery, resetFilters, 
    initializeFilters,
    setPublicListings} = listingSlice.actions